import { setTrailingSlash } from '../../server/helpers/setTrailingSlash.js';

/**
 * Generates a product page URL based on the provided URL and origin.
 * @param {string} url      - The URL to parse.
 * @param {string} origin  - The origin of the current product page.
 * @returns {string}        - The parsed URL.
 * @example
 * getProductPageUrl('https://buy.garmin.com/en-US/US/p/1234', 'https://www.garmin.com') => 'https://www.garmin.com/en-US/US/p/1234/'
 */
export const getProductPageUrl = (url, origin = 'https://www.garmin.com') => {
  if (!url) {
    throw new Error('url is required');
  }

  const productPageOrigin = origin;
  const urlOrigin = url.match(/^.*?(?=\/[a-z]{2}-[A-Z]{2}\/)/)?.[0] || '';
  const newUrl = (url || '').replace(urlOrigin, productPageOrigin);
  const updatedUrl = setTrailingSlash(newUrl.replace(/(\/[a-z][a-z]-[A-Z][A-Z]\/)(.*\/)(p\/)/, '$1$3'));
  return updatedUrl;
};
